document.addEventListener('DOMContentLoaded', function() {
  const swiperContainers = document.querySelectorAll('.normal-articles-container');
  const swiperInstances = new Map();
  
  function initializeSwiper() {
    const isTablet = window.innerWidth >= 768;
    
    swiperContainers.forEach((container) => {
      if (isTablet) {
        const swiperInstance = new Swiper(container, {
          slidesPerView: 2.2,
          spaceBetween: 20,
          grabCursor: true,
          breakpoints: {
            768: {
              spaceBetween: 32,
            },
            1280: {
              slidesPerView: 3,
              spaceBetween: 32,
            }
          },
        });

        swiperInstances.set(container, swiperInstance);
      }
    });
  }
  
  // Initialize on load
  initializeSwiper();
  
});
